import React, { useEffect, useState } from 'react';
import './EVOverride.scss';
import configuration from '../../config';
import getResponse from '../../utilities/FetchHelper';

import Modal from '../Modal';

const EVOverride = ({
  clearModal,
  modalImage,
  selectedGXId,
  setProcessing,
  errorMessage,
  setErrorMessage,
  errorMessageRef,
  updateDeviceData,
  showMobile,
  selectedGroup,
}) => {
  const [overrideForm, setOverrideForm] = useState({});
  let durationOptions = [];
  const hours = new Array(24).fill(0).map((_, i) => `${i + 1}`);

  for (let i = 0; i < hours.length; i++) {
    const hourOption = {
      label: '',
      value: null,
    };

    hourOption.label = hours[i] + `${hours[i] > 1 ? ' hours' : ' hour'}`;

    hourOption.value = hours[i] * 60;

    durationOptions.push(hourOption);
  }

  useEffect(() => {
    if (selectedGXId) {
      setOverrideForm((prevState) => ({
        ...prevState,
        evChargerGroupId: selectedGroup.evChargerGroupId,
        expiresInMinutes: 60,
      }));
    }
  }, [selectedGXId]);

  const setOverride = () => {
    setProcessing(true);
    clearModal();

    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        selectedGXId +
        '/gridInterconnect/evChargerGroup/override',
      true,
      'POST',
      JSON.stringify(overrideForm),
      updateDeviceData,
      setProcessing,
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
  };

  return (
    <div className="ev-override">
      <Modal
        modalTitle={'Group Override'}
        modalImage={modalImage}
        clearModal={clearModal}
        showMobile={showMobile}
        updateSettings={setOverride}
        renderModalContent={
          <div className="override-container">
            <h5>Override Settings</h5>

            <div className="override-settings">
              <div className="power">
                <label htmlFor="performance">Power Limit</label>
                <div>
                  <input
                    name="power-limit"
                    type="number"
                    placeholder="0"
                    onChange={(e) =>
                      setOverrideForm((prevState) => ({
                        ...prevState,
                        overridePercent: parseInt(e.target.value),
                      }))
                    }
                    min="1"
                    max="100"
                  ></input>
                  <span>%</span>
                </div>
              </div>

              <div className="duration">
                <label>Duration</label>
                <div className="duration-input">
                  <select
                    name="duration"
                    onChange={(e) =>
                      setOverrideForm((prevState) => ({
                        ...prevState,
                        expiresInMinutes: parseInt(e.target.value),
                      }))
                    }
                  >
                    {durationOptions.map((option) => (
                      <option value={option.value} key={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        }
      ></Modal>
    </div>
  );
};

export default EVOverride;
